/* eslint-disable @typescript-eslint/no-explicit-any */

import { getWCMJson } from "../utils/WcmAxiosApi";
import { wcmUrls } from "../shared/constants";
import { AvailableInvestmentStrategies } from "../model/AvailableInvestmentStrategies";
import { AvailableDateRanges, IndexDateRangeConfig } from "../model/AvailableDateRanges";
import { right, left, Either } from "fp-ts/lib/Either";
import { DatesModel, DatePresetsModel } from "../model/DatePresetsModel";
import { FetchableConfig } from "../model/CalculatorConfig";
import { Option, some, none } from "fp-ts/lib/Option";
import { CalculatorURLConfig } from "../model/CalculatorURLConfig";


function toDatePreset(indexConfigs: any) {

  const ranges = new Map<string, DatesModel>();
  for (const indexConfig of indexConfigs) {
    const i = indexConfig as IndexDateRangeConfig;
    const dates: DatesModel = { startYear: i.startYear, endYear: i.endYear };
    ranges.set(i.index, dates);
  }
  return new DatePresetsModel(ranges, undefined, false);
}

function toInvestmentStrategies(data: any): Option<AvailableInvestmentStrategies> {
  try {
    return some(new AvailableInvestmentStrategies(data.rules));
  } catch (err) {
    return none;
  }
}

function toCalculatorUrls(data: any): Option<CalculatorURLConfig> {
  try {
    return some(new CalculatorURLConfig(data.calculatorUrlRules));
  } catch (err) {
    return none;
  }
}

function toDateRanges(data: any): Option<AvailableDateRanges> {
  try {
    const indexDateRangeConfig: Array<IndexDateRangeConfig> = [];
    for (const indexConfig of data.datePresets) {
      indexDateRangeConfig.push(indexConfig as IndexDateRangeConfig)
    }
    return some(new AvailableDateRanges(indexDateRangeConfig))
  } catch(err) {
    return none;
  }
}

export async function getCalculatorConfig(setDatePresets: (d: DatePresetsModel) => void, userIdentifierStr: string): Promise<Either<Error, FetchableConfig>> {
  const url = wcmUrls.calculatorConfig;
  try {
    const rslt = await getWCMJson(url);

    const datePreset = toDatePreset(rslt['datePresets']);
    setDatePresets(datePreset);

    const dateRanges = toDateRanges(rslt);
    const strategies = toInvestmentStrategies(rslt);
    const calculatorUrls = toCalculatorUrls(rslt);
    const userIdentifier = userIdentifierStr ? some(userIdentifierStr) : none;

    const fetchable: FetchableConfig = { strategies, dateRanges, calculatorUrls, userIdentifier };
    return right(fetchable);
  } catch (err) {
    if (err instanceof Error) {
      return left(err);
    } else {
      return left(new Error("Unknown error: " + err));
    }
  }
}
